import { useMemo } from "react";
import { useTheme } from "../../../contexts/ThemeContext";
import { palette, status, accents, series, idleNeutral, heatRamp, accentPairs, accentFor, space, radius, font, elevation, motion, stagger, layout } from "../design/tokens";

// Resolves the full DashboardV2 design context for the current theme mode.
// Components call `const t = useDashTheme()` and read t.c (colors), t.s (spacing), etc.
// One hook → everything stays consistent and theme-reactive.
export function useDashTheme() {
  const { mode } = useTheme();
  const isDark = mode === "dark";

  return useMemo(() => {
    const c = isDark ? palette.dark : palette.light;
    return {
      isDark,
      c,                       // theme colors
      status,                  // semantic status colors
      accents,                 // legacy chart accent spread (see tokens.js caveat)
      series: isDark ? series.dark : series.light,  // validated categorical spread
      idle: isDark ? idleNeutral.dark : idleNeutral.light,
      heat: isDark ? heatRamp.dark : heatRamp.light,
      accentPairs,             // named families: pastel bg + dark same-hue fg
      accentFor,               // deterministic family from a seed string
      s: space,                // spacing scale
      layout,                  // page content max-width
      r: radius,               // radius scale
      font,                    // typography
      shadow: elevation(c),    // theme-aware shadows
      motion,                  // animation presets
      stagger,                 // grid reveal presets
    };
  }, [isDark]);
}
